import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Clear scroll locks left by modals / mobile menus / Google Picker. */
function clearDocumentScrollLocks() {
  const { body, documentElement } = document;
  body.style.overflow = '';
  body.style.position = '';
  body.style.top = '';
  body.style.left = '';
  body.style.right = '';
  body.style.width = '';
  documentElement.style.overflow = '';

  // Google Picker is not React-managed — cancel can leave a full-screen blocker
  document.querySelectorAll('.picker-dialog-bg, .picker-dialog').forEach((el) => {
    el.remove();
  });
}

/**
 * Scroll to top on route change and clear leftover body scroll locks.
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    clearDocumentScrollLocks();
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
